var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.702,
    height: 27.702,
    viewBox: "0 0 27.702 27.702",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "minus-svgrepo-com",
    transform: "translate(0.002)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3424",
    "data-name": "Group 3424"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3423",
    "data-name": "Group 3423"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_737",
    "data-name": "Path 737",
    d: "M13.851,0A13.851,13.851,0,1,0,27.7,13.85,13.851,13.851,0,0,0,13.851,0Zm0,26.317A12.466,12.466,0,1,1,26.317,13.851,12.466,12.466,0,0,1,13.851,26.317Z",
    fill: "#ee4e56"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3426",
    "data-name": "Group 3426",
    transform: "translate(6.233 13.159)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3425",
    "data-name": "Group 3425"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_738",
    "data-name": "Path 738",
    d: "M129.744,243.2H115.893a.693.693,0,0,0,0,1.385h13.851a.693.693,0,1,0,0-1.385Z",
    transform: "translate(-115.2 -243.2)",
    fill: "#ee4e56"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusIcon);
export default __webpack_public_path__ + "static/media/minus-icon.809503e364e0aa27005ee74feaa8fa18.svg";
export { ForwardRef as ReactComponent };